export default {
    en: {
        title: "Students"
    },
    zh: {
        title: "学生列表"
    }
}